<template>
  <div class="inner ht">
    <div class="ht-out-router">
      <span class="text-exceed-handle header-left"><a href="http://www.cnipa.gov.cn/" target="blank" title="">国家知识产权局门户网站</a></span>
      <span class="text-exceed-handle "><a href="http://zscqj.hubei.gov.cn/" target="blank" title="">湖北省知识产权局门户网站</a></span>
    </div>    
    <div class="ht-out-setting">
      <span class="text-exceed-handle"><a href="https://zscqj.hubei.gov.cn/ipsc/#/ssoHome" target="blank">管理桌面</a></span>
      <span v-if="userName" class="text-exceed-handle"><a href="javascript:void(0);">{{ userName }}</a></span>
      <span v-if="userName" class="text-exceed-handle"><a href="javascript:void(0);" @click="$router.push('/personCenter')">个人中心</a></span>
      <div class="ht-out-wrapper" v-if="!userName" @click="login"><span class="text-exceed-handle header-right"><a href="javascript:void(0)" title="">身份认证</a></span></div>
      <span v-else class="text-exceed-handle header-right"><a href="javascript:void(0)" title="" @click="loginOut">退出</a></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeHeader',
  components: { },
  created() {
    if (this.$route.query.s) {
      this.$http.setToken(this.$route.query.s)
      this.getUserInfo()
    }else {
      let token = this.$http.getToken()
      console.log('Token: ' , token)
      if (token) { // 政务网统一登录
        let userInfoStr = window.localStorage.getItem('userInfo')
        if (userInfoStr) {
          let userInfo = JSON.parse(userInfoStr)
          this.userName = userInfo.realName
        }
      }else {
        this.clearUserInfo()
      }
    }
  },
  data() {
    return {
      userName: ''
    }
  },
  methods: {
    login(){
      window.open(window.SITE_CONFIG['loginURL'],'_self')
    },
    loginOut(){
      this.clearUserInfo()
        alert('退出成功!')
        this.$router.push('homePage')
    },

    clearUserInfo(){
      this.$http.removeToken()
      this.userName = ''
      window.localStorage.removeItem('userInfo')
    },
    getUserInfo(){
      let _this = this
      this.$http({
        url: this.$http.adornUrl(`/getUserInfo`),
        method: 'get'
      }).then(({ data }) => {
        if (data.code === 0) {
          window.localStorage.setItem('userInfo',JSON.stringify(data.data))
          _this.userName = data.data.realName ? data.data.realName : data.data.entName
        }
      }) 
    }
  }
}
</script>